import React, { useEffect, useState } from "react";
import Diagrama from "../Diagrama";

// Modo presentacion: la arquitectura a pantalla completa, un paso a la vez con el texto grande. Flechas o espacio para avanzar, Esc para salir.
const Presentacion = ({ arq, onCerrar }) => {
    const [paso, setPaso] = useState(0);
    const total = arq.pasos.length;
    useEffect(() => {
        try { const el = document.documentElement; if (el.requestFullscreen && !document.fullscreenElement) el.requestFullscreen().catch(() => {}); } catch (e) { /* no se pudo */ }
        return () => { try { if (document.fullscreenElement) document.exitFullscreen(); } catch (e) { /* ya salio */ } };
    }, []);
    useEffect(() => {
        const f = (e) => {
            if (e.key === "ArrowRight" || e.key === " " || e.key === "PageDown") { e.preventDefault(); setPaso(p => Math.min(total - 1, p + 1)); }
            else if (e.key === "ArrowLeft" || e.key === "PageUp") { e.preventDefault(); setPaso(p => Math.max(0, p - 1)); }
            else if (e.key === "Escape") onCerrar();
        };
        window.addEventListener("keydown", f);
        return () => window.removeEventListener("keydown", f);
    }, [total]);
    useEffect(() => {
        const f = () => { if (!document.fullscreenElement) onCerrar(); };
        document.addEventListener("fullscreenchange", f);
        return () => document.removeEventListener("fullscreenchange", f);
    }, []);
    return (
        <div role="dialog" aria-modal="true" aria-label={`Presentación: ${arq.titulo}`} className="d-flex flex-column p-4"
            style={{ position: "fixed", inset: 0, zIndex: 3000, background: "var(--cui-body-bg, #fff)", color: "var(--cui-body-color, #212529)" }}>
            <div className="d-flex align-items-center mb-2">
                <h3 className="me-auto mb-0"><i className={`${arq.icono} me-2`} />{arq.titulo}</h3>
                <span className="badge text-bg-secondary me-3">Paso {paso + 1} de {total}</span>
                <button className="btn btn-outline-secondary" onClick={onCerrar}><i className="fa fa-times me-1" />Salir</button>
            </div>
            <div className="flex-grow-1 pres-dibujo" style={{ minHeight: 0 }}>
                <style>{".pres-dibujo svg { max-height: 58vh !important; }"}</style>
                <Diagrama patron="libre" nodos={arq.nodos} flujosLibres={arq.flujos} grupos={arq.grupos} color="#8C4FFF" paso={paso} />
            </div>
            <div className="text-center my-3" style={{ fontSize: "clamp(20px, 2.6vw, 34px)", minHeight: 90 }}>{arq.pasos[paso]}</div>
            <div className="d-flex justify-content-center gap-2">
                <button className="btn btn-lg btn-outline-primary" disabled={paso === 0} onClick={() => setPaso(p => p - 1)}><i className="fa fa-chevron-left me-1" />Anterior</button>
                <button className="btn btn-lg btn-primary" disabled={paso === total - 1} onClick={() => setPaso(p => p + 1)}>Siguiente<i className="fa fa-chevron-right ms-1" /></button>
            </div>
        </div>
    );
};

export default Presentacion;
